import React from "react";
import axios from "axios"

const About = () => {

  const [selectedFile, setSelectedFile] = React.useState(null)

  const fileSelectedHandler = (e) => {
   setSelectedFile(e.target.files[0])
  }

  const fileUploadHandler = () => {

    const fd = new FormData()
    fd.append('image', selectedFile, selectedFile.name)
axios.post("https://midamoapi.ge/api", fd).then((response) => {
      console.log(response)
    })
  }

//   { onUploadProgress: ProgressEvent => {console.log(Math.round(progressEvent.loaded / progressEvent.total * 100) + '%')}   
// }

  return <div className="about">
    <input type="file" onChange={fileSelectedHandler}/>
    <button onClick={fileUploadHandler}>Upload</button>
  </div>;
};

export default About;
